import React from 'react';

// Logo lives in /app/frontend/public, served at the site root
const LOGO_URL = '/shipmaster-logo.png';

export default function Logo({ variant = 'dark' }) {
  // For the dark footer, invert dark portions so the wordmark reads on dark bg
  const filterStyle =
    variant === 'light' ? { filter: 'brightness(0) invert(1)' } : undefined;

  return (
    <div className="flex items-center select-none">
      <img
        src={LOGO_URL}
        alt="Shipmaster Fulfillment"
        className="h-9 sm:h-10 w-auto object-contain"
        style={filterStyle}
        draggable={false}
      />
    </div>
  );
}
